import { call, put } from 'redux-saga/effects';
import PlanActions from '../Redux/PlanRedux';
import ErrorsActions from '../Redux/ErrorsRedux';

import * as services from '../Containers/Onboarding/services'

export function* getPlans({}) {
  try {
    const response = yield call(services.getPlans);
    if (response && response.ok) {
      // let mapSubscriptions = response.data.reduce((accumulator, currentValue) => ({...accumulator, [currentValue.id]: {...currentValue}}), {})
      yield put(PlanActions.plansSuccess(response.data ));
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null));
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'));
        } else {
          yield put(ErrorsActions.errorSave(response.data));
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'));
      }
      yield put(PlanActions.planFetchingReset());
    }
  } catch (e) {
    yield put(PlanActions.planFetchingReset());
    yield put(ErrorsActions.errorSave(`Server response error: ${e}`));
  }
}
